import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { Text, TextType } from 'ui-components/components/text';

import { OnboardCard } from '../../onboard-card';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';
import { ConnectLabelProviderModalContextProvider } from '../../../../../../components/modals/connect-label-provider-modal/context-provider';
import { ShippingServicesCardFooter } from './shipping-service-card-footer';
import { ShippingServicesCardBody } from './shipping-service-card-body';
import providers from './providers.svg';

import { messages } from '../../messages';
import { useWallet } from '../../../../../../wallet/hooks/use-wallet';
import { BYOAProvider } from './byoa-provider-complete-body';

export const ShippingServicesCard = () => {
  const intl = useIntl();
  const { isWalletRegistered } = useWallet();
  const { isShippingServiceComplete } = useHomePageOnboardContext();
  const shippingServiceConnected = isWalletRegistered ? messages.shippingServicesWalletComplete : messages.shippingServicesBYOLComplete;
  const title = isShippingServiceComplete ? shippingServiceConnected : messages.shippingServicesCardTitleIncomplete;

  const growlError = useCallback((errorMessage) => {
    NotificationService.showNotification({
      notificationType: NOTIFICATION_TYPE_ERROR,
      title: <Text textType={TextType.Description} value={messages.labelProviderErrorTitle} />,
      content: <Text textType={TextType.Paragraph} value={errorMessage} />,
    });
  }, []);

  const onProviderRegistrationFailure = useCallback(() => {
    growlError(messages.labelProviderError);
  }, [growlError]);

  const headerImage = useMemo(
    () =>
      isShippingServiceComplete && !isWalletRegistered ? (
        <BYOAProvider />
      ) : (
        <img alt={intl.formatMessage(messages.providersAltText)} src={providers} />
      ),
    [isShippingServiceComplete, isWalletRegistered, intl],
  );

  return (
    <OnboardCard headerImage={headerImage} isComplete={isShippingServiceComplete} title={title}>
      <ShippingServicesCardBody />
      <ConnectLabelProviderModalContextProvider setCuiError={onProviderRegistrationFailure}>
        <ShippingServicesCardFooter />
      </ConnectLabelProviderModalContextProvider>
    </OnboardCard>
  );
};
